import { render, staticRenderFns } from "./AccommodationVariant.vue?vue&type=template&id=11d8cc6a"
import script from "./AccommodationVariant.vue?vue&type=script&lang=js"
export * from "./AccommodationVariant.vue?vue&type=script&lang=js"
import style0 from "./AccommodationVariant.vue?vue&type=style&index=0&id=11d8cc6a&prod&lang=sass"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports